export default {
  disasterAuthorization: {
    title: 'Autorizzazione',
    text: 'Seleziona il tuo fornitore di dati e inserisci la chiave corrispondente del tuo utente HeiGIT Disaster Portal. Se non hai già un utente, richiedine uno inviando un\'e-mail a support[at]openrouteservice.heigit.org, specificando il tuo caso d\'uso. Anche senza chiave, l\'app può essere utilizzata in modalità di sola lettura.',
    save: 'Invia',
    enterTheAuthorizationKey: 'Inserisci la chiave qui',
    selectProvider: 'Seleziona il tuo fornitore di dati',
    useReadOnly: 'Utilizzare in modalità lettura',
    authenticateAsAdmin: 'Attiva qui la modalità di amministrazione',
    insertAValidKey: 'Deve essere inserita una chiave valida',
    insertAProvider: 'È necessario scegliere un fornitore di dati corrispondente alla tua autorizzazione'
  }
}
